import { forwardRef } from 'react';
import HeaderContainer from '../molecules/HeaderContainer';
import HeaderContent from '../molecules/HeaderContent';
import HeaderTitle from '../molecules/HeaderTitle';
import HeaderActions from '../molecules/HeaderActions';

export interface AppHeaderProps {
  title?: string;
  subtitle?: string;
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'minimal';
  size?: 'sm' | 'md' | 'lg';
  hasBorder?: boolean;
  hasShadow?: boolean;
  className?: string;
}

const AppHeader = forwardRef<HTMLDivElement, AppHeaderProps>(({
  title,
  subtitle,
  leftContent,
  centerContent,
  rightContent,
  variant = 'primary',
  size = 'md',
  hasBorder = true,
  hasShadow = false,
  className = '',
  ...props
}, ref) => (
    <HeaderContainer
      ref={ref}
      variant={variant}
      size={size}
      hasBorder={hasBorder}
      hasShadow={hasShadow}
      className={className}
      {...props}
    >
      {/* Left Content */}
      <HeaderContent position="left">
        {leftContent ?? (
          <div className="flex items-center space-x-3">
            {title && (
              <div className="flex flex-col">
                <HeaderTitle size={size}>{title}</HeaderTitle>
                {subtitle && (
                  <span className="text-sm text-text-muted">{subtitle}</span>
                )}
              </div>
            )}
          </div>
        )}
      </HeaderContent>

      {/* Center Content */}
      {centerContent && (
        <HeaderContent position="center">
          {centerContent}
        </HeaderContent>
      )}

      {/* Right Content */}
      {rightContent && (
        <HeaderContent position="right">
          <HeaderActions>
            {rightContent}
          </HeaderActions>
        </HeaderContent>
      )}
    </HeaderContainer>
  ));

AppHeader.displayName = 'AppHeader';

export default AppHeader;